import request from '@/utils/request';
// 人员统计
export const getUserList = (params: any) =>
  request({
    url: 'Statistics/userList',
    method: 'GET',
    params
  });

// 任务
export const getTaskList = (params: any) =>
  request({
    url: 'Statistics/taskList',
    method: 'GET',
    params
  });

//
// 客户统计

export const getCustomerList = (params: any) =>
  request({
    url: 'Statistics/customerList',
    method: 'GET',
    params
  });
  // 客户订单 导出
export const customerOrderList = (params: any) =>
  request({
    url: 'Statistics/customerOrderList',
    method: 'GET',
    params
  });
export const exportCustomerOrderListCount = (params: any) =>
  request({
    url: 'Statistics/exportCustomerOrderListCount',
    method: 'GET',
    params
  });
export const exportCustomerOrderLists = (params: any) =>
  request({
    url: 'Statistics/exportCustomerOrderLists',
    method: 'GET',
    params
  });

//
export const getStatistics = (params: any) =>
  request({
    url: 'Statistics/servicerList',
    method: 'GET',
    params
  });

export const getSerOrderList = (params: any) =>
  request({
    url: 'Statistics/servicerOrderList',
    method: 'GET',
    params
  });

export const getExportCount = (params: any) =>
  request({
    url: 'Statistics/exportSerOrder',
    method: 'GET',
    params
  });

export const exportSerOrderData = (params: any) =>
  request({
    url: 'Statistics/exportSerOrderData',
    method: 'GET',
    params
  });

export const getExportOrderDetailListCount = (params: any) =>
  request({
    url: 'Statistics/exportSerOrderList',
    method: 'GET',
    params
  });

export const exportSerOrderDetailListData = (params: any) =>
  request({
    url: 'Statistics/exportSerOrderListList',
    method: 'GET',
    params
  });
  // 客户统计

export const getCustomerStat = (params: any) =>
  request({
    url: 'Statistics/customerStat',
    method: 'GET',
    params
  });
  // 自定义报表
export const setDiyOrderTemplate = (data: any) =>
  request({
    url: 'Statistics/diyOrderTemplate',
    method: 'POST',
    data
  });
export const diyOrderTemplate = (params: any) =>
  request({
    url: 'Statistics/diyOrderTemplate',
    method: 'GET',
    params
  });
export const delDiyOrderTemplate = (data: any) =>
  request({
    url: 'Statistics/diyOrderTemplate',
    method: 'DELETE',
    data
  });
export const diyOrder = (params: any) =>
  request({
    url: 'Statistics/diyOrder',
    method: 'GET',
    params
  });
  // 服务方统计列表导出
export const serviceStatisticsListExport = (params: any) =>
  request({
    url: 'Statistics/serviceStatisticsListExport',
    method: 'GET',
    params
  });
  // 服务方统计详情导出
export const serviceStatisticsDetailExport = (params: any) =>
  request({
    url: 'Statistics/serviceStatisticsDetailExport',
    method: 'GET',
    params
  });
// 自定义报表统计详情导出
export const diyStaticsOrderExport = (params: any) =>
  request({
    url: 'Statistics/diyStatisticsOrderExport',
    method: 'GET',
    params
  });
  // 报修方分公司报修统计列表
export const branchCompanyRepairStatisticsList = (params: any) =>
  request({
    url: 'Statistics/branchCompanyRepairStatisticsList',
    method: 'GET',
    params
  });
  // 报修方分公司报修统计单词
export const branchCompanyRepairStatisticsExport = (params: any) =>
  request({
    url: 'Statistics/branchCompanyRepairStatisticsExport',
    method: 'GET',
    params
  });

// 新导出 人员任务
export const userTaskExport = (params: any) =>
  request({
    url: 'Statistics/userTaskExport',
    method: 'GET',
    params
  });
  // 新导出 人员
export const userExport = (params: any) =>
  request({
    url: 'Statistics/userExport',
    method: 'GET',
    params
  });
// 新导出 客户
export const customerExport = (params: any) =>
  request({
    url: 'Statistics/customerExport',
    method: 'GET',
    params
  });
  // 新导出 客户详情
export const customerOrderExport = (params: any) =>
  request({
    url: 'Statistics/customerOrderExport',
    method: 'GET',
    params
  });
